import Api from './axios';
import camelCase from '../utils/camelCase';
import { createCounterTopUrl } from '../utils/createCounterTopUrl';

const storeInfo = (storeId) => {
  let path = 'countertops/api/storeinfo/';

  let queryString = 'type=json';
  queryString = storeId ? `${queryString}&storeid=${encodeURIComponent(storeId)}` : queryString;

  path = `${path}?${queryString}`;

  return Api()
    .get(createCounterTopUrl(path))
    .then((response) => response.data)
    .then(camelCase);
};

const storesByZip = (zipcode, radius = 30) => {
  let path = 'countertops/api/storeinfo';

  let queryString = 'type=json';
  queryString = zipcode ? `${queryString}&address=${encodeURIComponent(zipcode)}` : queryString;
  queryString = radius ? `${queryString}&radius=${encodeURIComponent(radius)}` : queryString;
  queryString = `${queryString}&pagesize=${encodeURIComponent(40)}`;

  path = `${path}?${queryString}`;

  return Api()
    .get(createCounterTopUrl(path))
    .then((response) => response.data)
    .then(camelCase);
};

export { storeInfo, storesByZip };
